import Router from "./pages/shared/router";
import SessionTimeout from "./pages/shared/SessionTimeout";

function App() {
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  return (
    <>
      <SessionTimeout onLogout={handleLogout} />
      <Router />
    </>
  );
}

export default App;
